import { render, staticRenderFns } from "./EquipmentRelationshipDialog.vue?vue&type=template&id=3b612a4d&scoped=true&"
import script from "./EquipmentRelationshipDialog.vue?vue&type=script&lang=js&"
export * from "./EquipmentRelationshipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b612a4d",
  null
  
)

export default component.exports